// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UiS3","importantInfo":"styles_importantInfo___h3G7"};